import { SiteUnderMaintenance } from '../actions';
import store from '../reducers/store';

export function setSiteUnderMaintenanceOutsideReact() {
  store.dispatch(SiteUnderMaintenance());
}
